import { newLeadForwardingProjectSchema } from "./newLeadForwardingProjectSchema";
import { z } from "zod";

/**
 * @description Contains the project ID of the created project
 */
export const createOpportunity200Schema = z.coerce.string();

export type CreateOpportunity200 = z.infer<typeof createOpportunity200Schema>;

/**
 * @description 500 - Internal server error
 */
export const createOpportunity500Schema = z.unknown();

export type CreateOpportunity500 = z.infer<typeof createOpportunity500Schema>;

export const createOpportunityMutationRequestSchema = z.lazy(() => newLeadForwardingProjectSchema);

export type CreateOpportunityMutationRequest = z.infer<
  typeof createOpportunityMutationRequestSchema
>;

export const createOpportunityMutationResponseSchema = z.lazy(() => createOpportunity200Schema);

export type CreateOpportunityMutationResponse = z.infer<
  typeof createOpportunityMutationResponseSchema
>;
